const PHOTO_QUALITY_SUFFIX_RE = /_(1(?:\.5)?K|2K|4K)$/i;

export function parsePhotoPresetToken(value) {
  const raw = String(value || '').trim();
  if (!raw) {
    return { presetId: 'general', quality: null };
  }

  const match = raw.match(PHOTO_QUALITY_SUFFIX_RE);
  return {
    presetId: raw.replace(PHOTO_QUALITY_SUFFIX_RE, '').toLowerCase(),
    quality: match ? match[1].toUpperCase() : null,
  };
}
